// extracted by mini-css-extract-plugin
module.exports = {"new":"index_new_3xYOX","favorite":"index_favorite_3zn1D","thumb":"index_thumb_1dxST","image":"index_image_14EXO"};